// extracted by mini-css-extract-plugin
module.exports = {"Container":"Event_Container__MjaFD","Event":"Event_Event__3hcZC"};